import { intelligentPhotoCaptureConstants } from '../constants';
export const DAMAGE_CONNECTION_NEGOTIATION_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_CONNECTION_NEGOTIATION_REQUEST`;
export const DAMAGE_CONNECTION_NEGOTIATION_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_CONNECTION_NEGOTIATION_SUCCESS`;
export const DAMAGE_CONNECTION_NEGOTIATION_FAILURE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_CONNECTION_NEGOTIATION_FAILURE`;
export const DAMAGE_CONNECTION_NEGOTIATION_DELETE_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_CONNECTION_NEGOTIATION_DELETE_REQUEST`;
export const DAMAGE_CONNECTION_ON_RECEIVE_NOTIFICATION = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_CONNECTION_ON_RECEIVE_NOTIFICATION`;
export const photoCaptureIntelligentDamageConnectionRequestAction = () => ({
    type: DAMAGE_CONNECTION_NEGOTIATION_REQUEST,
    payload: undefined
});
export const photoCaptureIntelligentDamageConnectionDeleteRequestAction = () => ({
    type: DAMAGE_CONNECTION_NEGOTIATION_DELETE_REQUEST,
    payload: undefined
});
export const photoCaptureIntelligentDamageConnectionSuccessAction = (connectionId) => ({
    type: DAMAGE_CONNECTION_NEGOTIATION_SUCCESS,
    payload: { connectionId }
});
export const photoCaptureIntelligentDamageConnectionFailureAction = (failureMessage) => ({
    type: DAMAGE_CONNECTION_NEGOTIATION_FAILURE,
    payload: { failureMessage }
});
export const photoCaptureIntelligentDamageNotificationReceivedAction = (notification) => ({
    type: DAMAGE_CONNECTION_ON_RECEIVE_NOTIFICATION,
    payload: { notification }
});
//# sourceMappingURL=photoCaptureIntelligentDamageConnectionAction.js.map